interface functionalEndpointConfig extends types.endpoints.functionalEndpointConfig {}

const wcmParams = `connect/mobileapp_en/labels?source=library&srv=cmpnt&cmpntname=ModifiedLabels&updateafter=`;

const _asEndpoint = (url: string): types.endpoints.IEndpointConfig => {
	return {
		url: url,
	};
};

export const getNewTranslations: functionalEndpointConfig = (date: Date | string) => {
	return _asEndpoint(`${wcmParams}${date}`);
};

export const fetchTranslations = (language: string) => {
	return {
		url: `connect/${language === 'en' ? 'ebu_en' : 'ebu_ar'}/ebu_fe_labels/translations`,
		method: 'GET',
	};
};
